import type { MenuLinkItem } from "~/types";
import { SEKOU_COUNT } from "~/constants/sekou";
import { REVIEW_COUNT } from "~/constants/review";
import { PLAN_COUNT } from "~/constants/plan";
import { JUSYOU_REKI } from "~/constants/contest";

export default function () {
  // 共通メニューアイテム SPヘッダーメニュー・フッター
  const baseMenu: MenuLinkItem[] = [
    {
      name: "施工例",
      to: "/sekou",
      label: { count: SEKOU_COUNT, unit: "件以上" },
    },
    {
      name: "プラン事例",
      to: "/plan",
      label: { count: PLAN_COUNT, unit: "件以上" },
    },
    {
      name: "お客様の声",
      to: "/e_list",
      label: { count: REVIEW_COUNT, unit: "件以上" },
    },
    {
      name: "受賞作品",
      to: "/contents.php/contest",
      label: { count: JUSYOU_REKI, unit: "年連続受賞" },
    },
    { name: "最新情報", to: "/news" },
    { name: "ブログ", to: "/BLOG/Finfo" },

    { name: "ファミリー庭園とは", to: "/contents.php/what_famitei" },
    { name: "選ばれる理由", to: "/contents.php/otoku" },
    { name: "工事の流れ", to: "/contents.php/flow" },
    { name: "よくあるご質問", to: "/contents.php/qa" },
    { name: "単価一覧", to: "/contents.php/kouji" },
    { name: "お支払い方法", to: "/contents.php/payment" },
    { name: "アフターフォロー", to: "/contents.php/after" },
    { name: "施工対応エリア", to: "/contents.php/koujiarea" },
    { name: "会社概要", to: "/contents.php/profile" },
    { name: "店舗一覧", to: "/contents.php/shop" },
    { name: "採用情報", to: "/contents.php/recruit" },
    { name: "職人募集", to: "/recruit/contractor" },
    { name: "プライバシーポリシー", to: "/contents.php/privacy" },
    { name: "サイトマップ", to: "/contents.php/sitemap" },
  ];
  const headerMenu = [
    { name: "ファミリー庭園とは", to: "/contents.php/what_famitei" },
    { name: "施工例", to: "/sekou" },
    { name: "プラン事例", to: "/plan" },
    { name: "お客様の声", to: "/e_list" },
    { name: "店舗一覧", to: "/contents.php/shop" },
    { name: "工事の流れ", to: "/contents.php/flow" },
  ];
  const footerMenu = [
    ...baseMenu,
    ...[
      {
        name: "お問い合せ",
        to: "/inquiry/form",
      },
      {
        name: "Instagram",
        to: "https://www.instagram.com/ex.komikomi/",
        external: true,
      },
      {
        name: "Pinterest",
        to: "https://www.pinterest.jp/ex_komikomi/",
        external: true,
      },
      {
        name: "X(Twitter)",
        to: "https://twitter.com/family_teien",
        external: true,
      },
    ],
  ];

  return {
    baseMenu,
    headerMenu,
    footerMenu,
  };
}
